// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-table table {
  table-layout: fixed !important;
  width: 100% !important;
}

/* Verbesserte Zeilenabstände */
.ant-table-expanded-row .expanded-row td {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  
  /* Hover-Effekt für bessere Interaktion */
  .ant-table-row:hover + .ant-table-expanded-row {
    background: #f5f9ff !important;
    transition: background 0.3s;
  }
  
  /* Abgerundete Ecken für erste/letzte Zeile */
  .ant-table-expanded-row .expanded-row:first-child td {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  .ant-table-expanded-row .expanded-row:last-child td {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
.ant-table table {margin: 24px}
.ant-table-tbody > tr > td:nth-child(7) {text-align: right}
.ant-table-tbody > tr > td:nth-child(11) {text-align: right}

  /* Globale Lösung für alle Inputs */
.ant-input-number {
    -moz-appearance: textfield;
  }
  
  .ant-input-number::-webkit-outer-spin-button,
  .ant-input-number::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  /* Oder spezifisch für ein bestimmtes Input */
  .custom-number-input .ant-input-number::-webkit-outer-spin-button,
  .custom-number-input .ant-input-number::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }


  .icon-container {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 8px;
  }
  
  .icon-amount {
    flex: 1 1;
    text-align: left;
    white-space: nowrap; /* Verhindert Zeilenumbruch */
  }
  
  .icon-gray {
    font-size: 1.2em;
    color: rgba(128, 128, 128, 0.921);
    margin-left: auto; /* Icon nach rechts schieben */
    flex-shrink: 0; /* Verhindert Größenschrumpfung */
    vertical-align: middle;
  }

  .icon-black {
    font-size: 1.2em;
    color: black;
    margin-left: auto; /* Icon nach rechts schieben */
    flex-shrink: 0; /* Verhindert Größenschrumpfung */
    vertical-align: middle;
  }





  @media (max-width: 768px) {
    .icon-container {
      gap: 4px;
    }
    .icon-gray {
      font-size: 1em;
    }
  }

  .ReactCrop__crop-selection {
  touch-action: none;
}

.ReactCrop__drag-handle {
  touch-action: none;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;IACI,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA,yCAAyC;EACzC;IACE,8BAA8B;IAC9B,2BAA2B;EAC7B;;EAEA,6CAA6C;EAC7C;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;EACA;IACE,8BAA8B;IAC9B,+BAA+B;EACjC;AACF,kBAAkB,YAAY;AAC9B,yCAAyC,iBAAiB;AAC1D,0CAA0C,iBAAiB;;EAEzD,mCAAmC;AACrC;IACI,0BAA0B;EAC5B;;EAEA;;IAEE,wBAAwB;IACxB,SAAS;EACX;;EAEA,6CAA6C;EAC7C;;IAEE,wBAAwB;IACxB,SAAS;EACX;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,mBAAmB,EAAE,6BAA6B;EACpD;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB,EAAE,8BAA8B;IACjD,cAAc,EAAE,iCAAiC;IACjD,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB,EAAE,8BAA8B;IACjD,cAAc,EAAE,iCAAiC;IACjD,sBAAsB;EACxB;;;;;;EAMA;IACE;MACE,QAAQ;IACV;IACA;MACE,cAAc;IAChB;EACF;;EAEA;EACA,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".ant-table table {\n  table-layout: fixed !important;\n  width: 100% !important;\n}\n\n/* Verbesserte Zeilenabstände */\n.ant-table-expanded-row .expanded-row td {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n  \n  /* Hover-Effekt für bessere Interaktion */\n  .ant-table-row:hover + .ant-table-expanded-row {\n    background: #f5f9ff !important;\n    transition: background 0.3s;\n  }\n  \n  /* Abgerundete Ecken für erste/letzte Zeile */\n  .ant-table-expanded-row .expanded-row:first-child td {\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n  }\n  .ant-table-expanded-row .expanded-row:last-child td {\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n.ant-table table {margin: 24px}\n.ant-table-tbody > tr > td:nth-child(7) {text-align: right}\n.ant-table-tbody > tr > td:nth-child(11) {text-align: right}\n\n  /* Globale Lösung für alle Inputs */\n.ant-input-number {\n    -moz-appearance: textfield;\n  }\n  \n  .ant-input-number::-webkit-outer-spin-button,\n  .ant-input-number::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  \n  /* Oder spezifisch für ein bestimmtes Input */\n  .custom-number-input .ant-input-number::-webkit-outer-spin-button,\n  .custom-number-input .ant-input-number::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n\n  .icon-container {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 8px;\n  }\n  \n  .icon-amount {\n    flex: 1;\n    text-align: left;\n    white-space: nowrap; /* Verhindert Zeilenumbruch */\n  }\n  \n  .icon-gray {\n    font-size: 1.2em;\n    color: rgba(128, 128, 128, 0.921);\n    margin-left: auto; /* Icon nach rechts schieben */\n    flex-shrink: 0; /* Verhindert Größenschrumpfung */\n    vertical-align: middle;\n  }\n\n  .icon-black {\n    font-size: 1.2em;\n    color: black;\n    margin-left: auto; /* Icon nach rechts schieben */\n    flex-shrink: 0; /* Verhindert Größenschrumpfung */\n    vertical-align: middle;\n  }\n\n\n\n\n\n  @media (max-width: 768px) {\n    .icon-container {\n      gap: 4px;\n    }\n    .icon-gray {\n      font-size: 1em;\n    }\n  }\n\n  .ReactCrop__crop-selection {\n  touch-action: none;\n}\n\n.ReactCrop__drag-handle {\n  touch-action: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
